/**
 * date：2022-04-26
 * author：brian
 * purpose：公共接口的统一
 */

import { shareParam } from '@/api/modules/public.js';

const mixin = {
    data() {
        return {
            shareParamArray: []
        }
    },
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return currentUser.sysScope && currentUser.sysAdmin || currentUser.sysScope && !currentUser.sysAdmin
        }
    },
    created() {
    },
    methods: {
        /**
         *
         * @param {*} code 不填或scope，获取所有范围customer，获取所有客户
         * @param {*} type 0或者不填，带全部 + 代理 + 所有客户/范围1，不带全部+代理，只有所有客户/范围
         * @returns
         */
        shareParamFn(code, type) {
            return shareParam({ code: code, type: type })
        }
    }
}

export default mixin

